import { render, staticRenderFns } from "./FirstSectionItem.vue?vue&type=template&id=40ebe6c0&"
import script from "./FirstSectionItem.vue?vue&type=script&lang=js&"
export * from "./FirstSectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports